/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ITagEntity } from "src/client/react/src/staffhub/sh-models";
import { mutatorAction } from "satcheljs";
import schedulesViewStateStore from "../store/store";

/**
 * Add/remove a group/tag to/from the groups/tags filter list
 * @param tag the group/tag
 * @param selected whether the group/tag is selected, true to add to the filter list, false to remove from the filter list
 */
export const setTagFilter = mutatorAction(
    "setTagFilter",
    (tag: ITagEntity, selected: boolean) => {
        const { filteredTags } = schedulesViewStateStore();

        if (!selected && filteredTags.has(tag.id)) {
            filteredTags.delete(tag.id);
        } else if (selected && !filteredTags.has(tag.id)) {
            filteredTags.set(tag.id, tag);
        }
    }
);